import { render, staticRenderFns } from "./DragTable.vue?vue&type=template&id=f7fa0b14&scoped=true&"
import script from "./DragTable.vue?vue&type=script&lang=js&"
export * from "./DragTable.vue?vue&type=script&lang=js&"
import style0 from "./DragTable.vue?vue&type=style&index=0&id=f7fa0b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fa0b14",
  null
  
)

export default component.exports